import { Component, EventEmitter, OnInit } from '@angular/core';

@Component({
  selector: 'app-button-edit',
  template: `
    <ng-container>
      <button mat-icon-button (click)="click.emit($event)" matTooltip="{{ 'shared.edit' | translate }}" matTooltipPosition="after">
        <mat-icon svgIcon="edit_icon" class="scale-09"></mat-icon>
      </button>
    </ng-container>
  `,
  styles: [``],
})
export class ButtonEditComponent implements OnInit {
  click = new EventEmitter();
  constructor() {}

  ngOnInit(): void {}
}
